import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchSelect from '../components/SearchSelect';
import { jobLabel } from '../utils/ui';

const API_BASE = process.env.REACT_APP_API_BASE || 'https://app.titanelectricreno.com:8080/api';
function getToken() { try { return JSON.parse(localStorage.getItem('titan_session') || 'null')?.token; } catch { return null; } }
function apiFetch(path, opts = {}) {
  return fetch(`${API_BASE}${path}`, { ...opts, headers: { 'Content-Type': 'application/json', ...(getToken() ? { 'x-worker-token': getToken() } : {}), ...opts.headers } })
    .then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));
}
const fmt = iso => { if (!iso) return ''; const d = new Date(iso); return isNaN(d) ? '' : d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }); };
const STATUS = {
  open: { label: 'Sent · unseen', bg: '#fef2f2', color: '#b91c1c' },
  acknowledged: { label: 'Seen · on it', bg: '#fffbeb', color: '#b45309' },
  done: { label: 'Done', bg: '#f0fdf4', color: '#15803d' },
  scheduled: { label: 'Scheduled', bg: '#eff6ff', color: '#1d4ed8' },
};
const inp = { width: '100%', padding: '13px 14px', borderRadius: 10, border: '1.5px solid #ddd', fontSize: 15, boxSizing: 'border-box', background: '#fff' };

export default function Directives() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [sent, setSent] = useState([]);
  const [toUserIds, setToUserIds] = useState([]);   // as many as you like — each gets their own directive
  const [sendDate, setSendDate] = useState('');       // blank = now; a date holds it until 2am that morning
  const [projectId, setProjectId] = useState('');
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);
  const [err, setErr] = useState('');

  function loadSent() { apiFetch('/directives/sent').then(d => setSent(Array.isArray(d) ? d : [])).catch(() => {}); }
  useEffect(() => {
    apiFetch('/users').then(u => setUsers(Array.isArray(u) ? u.sort((a, b) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`)) : [])).catch(() => {});
    apiFetch('/projects?scope=current').then(p => setProjects(Array.isArray(p) ? p : [])).catch(() => {});
    loadSent();
  }, []);

  const nameOf = id => { const u = users.find(x => String(x.id) === String(id)); return u ? `${u.firstName} ${u.lastName}` : 'someone'; };
  async function send() {
    if (!toUserIds.length || !text.trim()) { setErr('Pick at least one person and type the ask.'); return; }
    setSending(true); setErr('');
    const failed = [];
    for (const toUserId of toUserIds) {
      try { await apiFetch('/directives', { method: 'POST', body: JSON.stringify({ toUserId, text: text.trim(), projectId: projectId || null, sendDate: sendDate || null }) }); }
      catch { failed.push(toUserId); }
    }
    loadSent();
    if (failed.length) { setToUserIds(failed); setErr(`Didn't send to ${failed.map(nameOf).join(', ')} — try again.`); }
    else { setText(''); setProjectId(''); setSendDate(''); setToUserIds([]); }
    setSending(false);
  }
  async function cancel(id) {
    if (!window.confirm('Remove this directive?')) return;
    try { await apiFetch(`/directives/${id}`, { method: 'DELETE' }); setSent(s => s.filter(x => x.id !== id)); } catch {}
  }

  const scheduled = sent.filter(d => d.status === 'scheduled');
  const active = sent.filter(d => d.status !== 'done' && d.status !== 'scheduled');
  const done = sent.filter(d => d.status === 'done');

  return (
    <div className="page" style={{ background: '#f7f7f7' }}>
      <div className="top-bar">
        <button onClick={() => navigate('/dashboard')} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', color: '#111' }}>
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M14 4l-7 7 7 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <div className="top-bar-wordmark" style={{ flex: 1, textAlign: 'center' }}>TITAN <span>ELECTRIC</span></div>
        <div style={{ width: 22 }} />
      </div>

      <div style={{ padding: '20px 16px 100px' }}>
        <div style={{ fontSize: 22, fontWeight: 800, color: '#111', marginBottom: 4 }}>Directives</div>
        <div style={{ fontSize: 13, color: '#666', marginBottom: 18 }}>Hand someone their #1 task — track sent → seen → done.</div>

        {/* Send */}
        <div style={{ background: '#fff', border: '1px solid #eee', borderTop: '3px solid #dc2626', borderRadius: 14, padding: 16, marginBottom: 22 }}>
          <div style={{ fontSize: 12, fontWeight: 800, color: '#b91c1c', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 12 }}>🔴 Send a Priority</div>
          <label style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase' }}>To{toUserIds.length > 1 ? ` · ${toUserIds.length} people` : ''}</label>
          <div style={{ marginTop: 3, marginBottom: 12 }}>
            {toUserIds.length > 0 && (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 6 }}>
                {toUserIds.map(id => (
                  <span key={id} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '5px 11px', borderRadius: 999, background: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b', fontSize: 13, fontWeight: 700 }}>
                    {nameOf(id)}
                    <button onClick={() => setToUserIds(l => l.filter(x => x !== id))} style={{ background: 'none', border: 'none', color: '#b91c1c', fontSize: 16, cursor: 'pointer', padding: 0, lineHeight: 1 }}>×</button>
                  </span>
                ))}
              </div>
            )}
            <SearchSelect value="" onChange={id => { if (id && !toUserIds.includes(id)) setToUserIds(l => [...l, id]); }} placeholder={toUserIds.length ? 'Add another person…' : 'Type a name…'} inputStyle={inp}
              options={users.filter(u => !toUserIds.includes(u.id)).map(u => ({ value: u.id, label: `${u.firstName} ${u.lastName}`, sub: u.role }))} />
          </div>
          <label style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase' }}>The ask</label>
          <textarea value={text} onChange={e => setText(e.target.value)} rows={3} placeholder="What do you need them to do right now?" style={{ ...inp, marginTop: 3, marginBottom: 12, resize: 'vertical', fontFamily: 'inherit' }} />
          <label style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase' }}>Job (optional)</label>
          <div style={{ marginTop: 3 }}>
            <SearchSelect value={projectId} onChange={setProjectId} placeholder="Type a job…" inputStyle={inp}
              options={[{ value: '', label: '— None —' }, ...projects.map(p => ({ value: p.id, label: jobLabel(p) }))]} />
          </div>
          <label style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', display: 'block', marginTop: 12 }}>Send on <span style={{ fontWeight: 500, textTransform: 'none' }}>(optional — held until 2am that morning)</span></label>
          <input type="date" value={sendDate} min={new Date().toLocaleDateString('en-CA')} onChange={e => setSendDate(e.target.value)} style={{ ...inp, marginTop: 3 }} />
          {err && <div style={{ color: '#dc2626', fontSize: 13, marginTop: 10 }}>{err}</div>}
          <button onClick={send} disabled={sending}
            style={{ width: '100%', marginTop: 14, padding: '14px', borderRadius: 12, border: 'none', background: sending ? '#ccc' : '#dc2626', color: '#fff', fontSize: 16, fontWeight: 800, cursor: 'pointer' }}>
            {sending ? 'Sending…' : sendDate ? `Schedule for ${new Date(sendDate + 'T12:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}${toUserIds.length > 1 ? ` · ${toUserIds.length} people` : ''} →` : `Send Priority${toUserIds.length > 1 ? ` to ${toUserIds.length} people` : ''} →`}
          </button>
        </div>

        {scheduled.length > 0 && (<>
          <div style={{ fontSize: 12, fontWeight: 800, color: '#888', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10 }}>Scheduled ({scheduled.length})</div>
          {scheduled.map(d => <Row key={d.id} d={d} onCancel={cancel} />)}
        </>)}
        <div style={{ fontSize: 12, fontWeight: 800, color: '#888', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10 }}>Active ({active.length})</div>
        {active.length === 0 ? (
          <div style={{ color: '#9ca3af', fontSize: 14, textAlign: 'center', padding: '16px 0', marginBottom: 20 }}>No active directives.</div>
        ) : active.map(d => <Row key={d.id} d={d} onCancel={cancel} />)}

        {done.length > 0 && (<>
          <div style={{ fontSize: 12, fontWeight: 800, color: '#888', textTransform: 'uppercase', letterSpacing: 0.5, margin: '10px 0' }}>Completed</div>
          {done.map(d => <Row key={d.id} d={d} onCancel={cancel} />)}
        </>)}
      </div>
    </div>
  );
}

function Row({ d, onCancel }) {
  const sc = STATUS[d.status] || STATUS.open;
  return (
    <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: '13px 14px', marginBottom: 10, display: 'flex', gap: 12, alignItems: 'flex-start', opacity: d.status === 'done' ? 0.7 : 1 }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 3 }}>
          <span style={{ fontWeight: 800, fontSize: 14, color: '#111' }}>{d.to_name}</span>
          <span style={{ fontSize: 11, fontWeight: 700, background: sc.bg, color: sc.color, padding: '2px 9px', borderRadius: 20 }}>{sc.label}{d.status === 'scheduled' && d.send_date ? ` · ${new Date(d.send_date + 'T12:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}` : ''}</span>
          {d.mine === false && d.from_name && <span style={{ fontSize: 11, color: '#6b7280' }}>from {d.from_name}</span>}
        </div>
        <div style={{ fontSize: 14, color: '#111' }}>{d.text}</div>
        {d.project_number && <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>📍 {d.project_number}</div>}
        {d.reply && <div style={{ fontSize: 12.5, color: '#b45309', marginTop: 3, fontStyle: 'italic' }}>“{d.reply}”</div>}
        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 5 }}>Sent {fmt(d.created_at)}{d.acknowledged_at ? ` · Seen ${fmt(d.acknowledged_at)}` : ''}{d.done_at ? ` · Done ${fmt(d.done_at)}` : ''}</div>
      </div>
      <button onClick={() => onCancel(d.id)} style={{ background: 'none', border: 'none', color: '#d1d5db', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
    </div>
  );
}
